import { AfterViewChecked, ChangeDetectorRef, Component } from '@angular/core';
import { LoaderService } from './services/loader.service';

@Component({
  selector: 'fs-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})

export class AppComponent implements AfterViewChecked {
  isLoading = false;

  constructor(
    private loaderService: LoaderService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.loaderService.displayLoader$.subscribe(isLoading => this.isLoading = isLoading);
  }

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }
}
